module.exports = __webpack_public_path__ + "static/media/alert.5f10cab0.svg";